import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import * as RaceResults from 'components/raceResults/RaceResults';
export class ScrollingResults extends Component {

  static propTypes = {
    results: PropTypes.object.isRequired,
    races: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
  };

  isRaceResults = () => (this.props.settings['type'] || 'race') === 'race';
  isReportResults = () => !this.isRaceResults();

  hasResults = () => {
    const { results } = this.props;
    return !Array.isArray(results);
  };

  getResults = () => {
    const { results } = this.props;
    if(this.isReportResults()) return [results.rows] || [[]];
    else return _.pickBy(results, (entries) => entries.length > 0)
  };

  getColumns = () => {
    const { results } = this.props;
    if(this.isReportResults()) return results.columns;
    return []; // not important for regular results (it is hardcoded)
  };

  getRace = (index) => {
    const { races, results } = this.props;
    if(this.isRaceResults()) return races[index];
    else return results.race;
  };

  getAnimationSettings = (index) => {
    const { settings } = this.props;
    if(this.isRaceResults()) return index ?
      settings.race[index] : Object.values(settings.race)[0];
    else return {
      results_per_page: this.getResults()[0] ? this.getResults()[0].length : 0,
      title: settings.title,
    };
  };

  getColumnRatio = () => {
    const { results } = this.props;
    if(this.isReportResults()) return results.columnsRatio;
    else return []; // not used for race results
  };

  render() {
    const { settings } = this.props;
    const Animation = RaceResults[settings.animation_type];
    const defaultBackgroundColor = '#011328';
    const defaultHeaderColor     = '#333';
    let speed = settings.speed || 2;
    if(settings.background_color) {
      document.getElementsByTagName('body')[0].style.background = settings.background_color;
    }
    let haveResults = this.hasResults();
    return (
      <section className="scrolling-results wrapper table" style={{fontSize: (settings.font_size || 24) + 'px'}}>
        <ul>
          {
            haveResults ?
            _.map(
              this.getResults(),
              (entries, idx) =>
                <Animation
                    key={'race-result-' + idx}
                    entries={entries}
                    animationType={settings.animation_type}
                    race={this.getRace(idx)}
                    settings={this.getAnimationSettings(idx)}
                    speed= {speed}
                    headerColor={settings.header_color || defaultHeaderColor }
                    backgroundColor={settings.background_color || defaultBackgroundColor}
                    haveResults={haveResults}
                    panelSettings={settings}
                    columns={this.getColumns()}
                    columnsRatio={this.getColumnRatio()}
                    isRaceResults={this.isRaceResults()}
                    isReportResults={this.isReportResults()}/>
            ) : <Animation
                    entries={[]}
                    animationType={settings.animation_type}
                    race={this.getRace(0)}
                    settings={this.getAnimationSettings(0)}
                    speed= {speed}
                    headerColor={settings.header_color || defaultHeaderColor}
                    backgroundColor={settings.background_color || defaultBackgroundColor}
                    haveResults={haveResults}
                    panelSettings={settings}
                    columns={this.getColumns()}
                    columnsRatio={this.getColumnRatio()}
                    isRaceResults={this.isRaceResults()}
                    isReportResults={this.isReportResults()}/>
          }
        </ul>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./components/scrollingResults/ScrollingResults.js